import { FormControl, FormHelperText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AppContext } from '../../../app-context';
import { get } from '../../../features/common/http.services';
import { isNotNull } from '../../../features/common/util.services';
import './i-auto-complete.style.scss';

export interface IAutoCompleteItem {
    value: any,
    name: string
}

export interface IAutoCompleteProps {
    label: string,
    name: string,
    value?: string,
    itemList?: any[], // IAutoCompleteItem[],
    type?: string
    onChangeEvent?: any
    required?: boolean;
    rules?: any;
    url?: any;
    disabled?: boolean;
}

const IAutoComplete = (props: IAutoCompleteProps) => {
    const [open, setOpen] = useState(false);
    const MIN_CHARACTERS = 3;
    const [inputValue, setInputValue] = useState('');
    const appContext = useContext(AppContext);
    const [itemList, setItemList] = useState<any[]>(props.itemList ? props.itemList : []);
    const { control, register, setValue } = useFormContext();
    const [loader, setLoader] = useState(false);
    const handleInputChange = (event: any , newInputValue: any, reason: any) => {
        setInputValue(newInputValue);
        if (reason === 'reset' || newInputValue.length < MIN_CHARACTERS) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    };
    const onChangeEvent = (e: any, newValue: any) => {
        const value = newValue;
        setValue(props.name, value);
        if (props.onChangeEvent) {
            props.onChangeEvent(e);
        }
    }

    useEffect(() => {
        if (isNotNull(props.url)) {
            // setLoader(true);
            get(props.url, appContext,
                (response: any) => {
                    setItemList(response.data);
                    setLoader(false);
                }, (error: any) => {
                    console.log(error);
                    setLoader(false);
                    appContext.setErrorMessage(error.message);
                });
        }
    }, [props.url]);

    useEffect(() => {
        setItemList(props.itemList ? props.itemList : []);
    }, [props.itemList]);

    return loader ? <></> : <Controller
        control={control}
        name={props.name}
        rules={{
            required: {
                value: props.required,
                message: "Required Field"
            },
            ...props.rules
        }}
        render={({ field, fieldState }) => (<FormControl fullWidth>
            <Autocomplete
                {...field}
                {...register(props.name)}
                open={open}
                onClose={() => setOpen(false)}
                onInputChange={handleInputChange}
                inputValue={inputValue}
                size="small"
                className="i-autocomplete"
                disablePortal
                options={itemList}
                onChange={onChangeEvent}
                renderInput={(params) => <TextField {...params} label={props.label} />}
            />
            <FormHelperText error={isNotNull(fieldState.error)}>{fieldState.error ? fieldState.error.message : null}</FormHelperText>
        </FormControl>
        )}
    />

};

export default IAutoComplete;